import {Component, ElementRef, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {AConst} from '../../core/a-const.enum';
import {ContentMenu} from '../../core/definitions/object-content-tab/content-menus';

@Component({
  selector: 'app-object-content-dropdown-tab',
  templateUrl: './object-content-dropdown-tab.component.html',
  styleUrls: ['./object-content-dropdown-tab.component.scss']
})
export class ObjectContentDropdownTabComponent implements OnChanges {

  @Input() menu: ContentMenu;
  @Input() isEditing: boolean;
  @Output() menuOpened = new EventEmitter();

  AConst = AConst;
  private dropdownTabItem;

  constructor(private dropdownTabElementRef: ElementRef) {
  }

  ngOnChanges() {
    this.dropdownTabItem = this.dropdownTabElementRef.nativeElement;
  }

  openMenu() {
    this.menuOpened.emit(this.menu);
  }

  getDropdownTabElement() {
    return this.dropdownTabElementRef.nativeElement;
  }

}
